import { useRouter } from "next/router";
import ImageBox from "./HomePoojaImageBox";
import ImageWrapper from "../ImageComponent/ImageWrapper";
import { getCookieItem } from "@/utils/utils";
const HomePoojas = ({ data }) => {
  const imageBoxesData = data.boxesData;
  const boxHeight = data.boxHeight;
  const boxWidth = data.boxWidth;
  const router = useRouter();

  const handlePoojaOnClick = (poojaName) => {
    const locationName = getCookieItem("location_name")?.toLowerCase();
    const languageName = getCookieItem("language_name")?.toLowerCase();
    const routerPath = `/${languageName}/${locationName}/pooja/${poojaName}`;
    router.push(routerPath);
  };

  return (
    <div className="flex flex-col text-Default z-0">
      <h3 className="flex flex-row justify-start items-start mt-5 gap-4 text-md md:text-lg lg:text-2xl xl:text-[34px] 2xl:text-4xl font-bastoni tracking-wide px-5 xs:px-7 sm:px-11 md:px-16 lg:px-20 xl:px-35">
        {data.title}
        <div className="flex align-top items-start relative w-5 h-5 md:w-7 md:h-7 lg:w-8 lg:h-8 xl:w-10 xl:h-10">
          <ImageWrapper
            src={data.titleImage}
            alt="Title Image"
            className="w-full h-full top-0 left-0 object-cover rounded-2xl"
          />
        </div>
      </h3>
      <div className="overflow-x-auto scrollbar-hide">
        <div className="p-1 md:mt-5 flex gap-2 md:gap-4 md:pb-5 px-5 xs:px-7 sm:px-11 md:px-16 lg:px-20 xl:px-35">
          {imageBoxesData &&
            imageBoxesData.map((boxData) => (
              <ImageBox
                key={boxData._id}
                slug={boxData.slug}
                name={boxData.name}
                imageUrl={
                  boxData.media[0].mediaUrl
                    ? boxData.media[0].mediaUrl
                    : "/image/White.svg"
                }
                altText={boxData.name}
                boxHeight={boxHeight}
                boxWidth={boxWidth}
                onClick={handlePoojaOnClick}
              />
            ))}
        </div>
      </div>
      <div className="flex flex-row justify-center my-4 xs:my-6 sm:my-8 md:my-14 px-5 xs:px-7 sm:px-11 md:px-16 lg:px-20 xl:px-35">
        <ImageWrapper
          src="/icons/Group641.svg"
          alt="Title Image"
          width={270}
          height={40}
        />
      </div>
    </div>
  );
};

export default HomePoojas;
